import PropTypes from "prop-types";
import { useThemeContext } from "../../context/themeContext";

const DotPagination = ({ totalDots, currentDot, setCurrentDot }) => {
  const { theme } = useThemeContext();

  const handleDotClick = (index) => {
    setCurrentDot(index + 1);
  };

  return (
    <div className="flex gap-2">
      {Array.from({ length: totalDots }, (_, index) => (
        <button
          key={index}
          onClick={() => handleDotClick(index)}
          className={`w-[10px] h-[10px] rounded-full flex gap-2 text-[10px] justify-center items-center font-medium p-[5px] ${
            index + 1 === currentDot
              ? theme === "staff"
                ? "bg-[#1877D3]"
                : "bg-[#EAAA00]"
              : "bg-[#E3E3E3]"
          }`}
        />
      ))}
    </div>
  );
};

DotPagination.propTypes = {
  totalDots: PropTypes.number.isRequired,
  currentDot: PropTypes.number.isRequired,
  setCurrentDot: PropTypes.func.isRequired,
};

export default DotPagination;
